'use client';
import Image from 'next/image';
import React from 'react';
import {
  NavbarContent,
  NavbarMenu,
  NavbarMenuItem,
  NavbarMenuToggle,
} from '@heroui/react';
import { navigationLinks } from '../config/navigation-links';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useCustomizationsContext } from '../customizations-provider';
import MarkdownLink from './markdown-link';

type MobileNavbarMenuProps = {
  isMenuOpen: boolean;
  isAboutPage: boolean;
  setIsMenuOpen: (open: boolean) => void;
};

export default function MobileNavbarMenu({
  isMenuOpen,
  isAboutPage,
  setIsMenuOpen,
}: MobileNavbarMenuProps) {
  const pathName = usePathname();
  const color = isAboutPage ? 'white' : 'black';
  const t = useTranslations('menu');
  const c = useCustomizationsContext();
  const menuIcons = {
    close: c(`menu.${color}.close`),
    burger: c(`menu.${color}.burger`),
  };

  const menuIcon = (type: 'close' | 'burger') => {
    const icon = menuIcons[type] ?? menuIcons.burger;
    return (
      <Image
        src={icon.url}
        alt={icon.description}
        width={icon.width}
        height={icon.height}
        className="w-[16px] h-[16px]"
      />
    );
  };

  return (
    <div className="md:hidden">
      <NavbarContent justify="end">
        <NavbarMenuToggle
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          icon={isMenuOpen ? menuIcon('close') : menuIcon('burger')}
          className="[&_.sr-only]:hidden"
        />
      </NavbarContent>
      <NavbarMenu className="px-4 bg-primary w-full pt-[270px] absolute z-[90] text-center top-15">
        {navigationLinks(t).map((item) => (
          <NavbarMenuItem
            key={item.label}
            className={`pt-1 font-montserrat text-[40px] ${item.link == pathName ? 'font-bold' : null}`}
            onClick={() => setIsMenuOpen(false)}
          >
            <MarkdownLink text={item.label} />
          </NavbarMenuItem>
        ))}
      </NavbarMenu>
    </div>
  );
}
